<template>
  <client-only>
    <div id="page-404" class="container">
      <v-layout column justify-center mt-4>
        <v-flex xl3 lg3>
          <img src="@/static/404.jpg" alt="page not found" />
        </v-flex>
        <v-flex>
          <br />
          <p class="display-22">
            לא מצאנו את הדף שביקשת,
            <br />אבל אולי תוכל/י
            <a href="/" class="display-22">למצוא כאן עבודה.</a>
          </p>
        </v-flex>
      </v-layout>
    </div>
  </client-only>
</template>

<script>
export default {
  layout: 'innerPage', // you can set a custom layout for the error page
}
</script>

<style lang="scss" scoped>
.container {
  text-align: center;
}

#page-404 img {
  max-width: 300px;
}
</style>
